import { useTranslation } from 'react-i18next'
import { LuCalendarDays, LuHash, LuMapPin, LuSparkles, LuUmbrella } from 'react-icons/lu'
import { Box, Text } from '@chakra-ui/react'

import { OrderItemInfo } from 'appTypes/orders'
import { formatItemCardDateDate } from 'components/ui/ItemCard/helpers'
import { removeDecimals } from 'utils/removeDecimals'

import OrderItemInfoWithIcon from './OrderItemInfoWithIcon'
import { JSX } from 'react'

type Props = {
  orderItemInfo: OrderItemInfo
}

const OrderItemPickupInfo = ({ orderItemInfo }: Props): JSX.Element => {
  const { t } = useTranslation(['common', 'statuses'])

  const { orderItem, location } = orderItemInfo
  const { rentedFrom, rentedTo, productData, resignFromCleaning, resignFromInsurance, resignFromDeductibles, amount } =
    orderItem

  return (
    <Box width="100%" display="flex" flexDirection="column" gridGap="12px">
      {location && (
        <OrderItemInfoWithIcon icon={<LuMapPin size={12} />} fontWeight={700}>
          <>
            <Text fontSize="smd" height="18px">
              {location.name}
            </Text>
            <Text fontSize="sm" color="leid.mrkereGrnn" height="18px">
              {location.address}
            </Text>
          </>
        </OrderItemInfoWithIcon>
      )}

      {rentedFrom && (
        <OrderItemInfoWithIcon icon={<LuCalendarDays size={12} />}>
          <>
            <Text as="span" color="leid.mrkereGrnn">
              {t('common:pickup')}:{' '}
            </Text>
            {formatItemCardDateDate(rentedFrom)}
          </>
        </OrderItemInfoWithIcon>
      )}
      {rentedTo && (
        <OrderItemInfoWithIcon icon={<LuCalendarDays size={12} />}>
          <>
            <Text as="span" color="leid.mrkereGrnn">
              {t('common:return')}:{' '}
            </Text>
            {formatItemCardDateDate(rentedTo)}
          </>
        </OrderItemInfoWithIcon>
      )}
      {amount > 1 && (
        <OrderItemInfoWithIcon icon={<LuHash size={12} />}>
          <>
            <Text as="span" color="leid.mrkereGrnn">
              {t('common:Amount')}:{' '}
            </Text>
            {amount}
          </>
        </OrderItemInfoWithIcon>
      )}
      {!productData?.complementary && orderItem.cleaningPrice !== 0 && (
        <OrderItemInfoWithIcon icon={<LuSparkles size={12} />}>
          <>
            <Text as="span" color="leid.mrkereGrnn">
              {t('common:cleaning')}:{' '}
            </Text>
            {resignFromCleaning ? (
              <Text as="span">{t('common:notIncluded')}</Text>
            ) : (
              `${removeDecimals(orderItem.cleaningPrice)} ${t('common:nok')}`
            )}
          </>
        </OrderItemInfoWithIcon>
      )}
      {!productData?.complementary && (
        <OrderItemInfoWithIcon icon={<LuUmbrella size={12} />}>
          <>
            <Text as="span" color="leid.mrkereGrnn">
              {t('common:reductionOfDeductible')}:{' '}
            </Text>
            {resignFromDeductibles ? (
              <Text as="span">{t('common:notIncluded')}</Text>
            ) : (
              <>
                <Text as="span">
                  {removeDecimals(orderItem.deductiblesPrice)} {t('common:nok')}
                </Text>
              </>
            )}
          </>
        </OrderItemInfoWithIcon>
      )}
      {!productData?.complementary && (
        <OrderItemInfoWithIcon icon={<LuUmbrella size={12} />}>
          <>
            <Text as="span" color="leid.mrkereGrnn">
              {t('common:insurance')}:{' '}
            </Text>
            {resignFromInsurance ? (
              <Text as="span">{t('common:notIncluded')}</Text>
            ) : (
              `${removeDecimals(orderItem.insurancePrice)} ${t('common:nok')}`
            )}
          </>
        </OrderItemInfoWithIcon>
      )}
    </Box>
  )
}

export default OrderItemPickupInfo
